// test990
(990 && 0);
